function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "#34495E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.414 16.163a6.417 6.417 0 11-12.833 0 6.417 6.417 0 0112.833 0z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.036 16.163a6.417 6.417 0 11-12.834 0 6.417 6.417 0 0112.834 0z",
    fill: "#F1C40F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.202 16.163a6.4 6.4 0 002.106 4.753 6.4 6.4 0 002.106-4.753 6.4 6.4 0 00-2.106-4.754 6.4 6.4 0 00-2.106 4.754z",
    fill: "#F39C12"
  }));
};

SvgMastercard.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgMastercard.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgMastercard;